module.exports = __webpack_public_path__ + "img/partner-9.806c76df.svg";